<template>
  <div>
    <div class="d-flex justify-content-center mt-2">
        <button class="btn-dowload" @click="print()"><i class="fas fa-file-pdf"></i> BAIXAR PDF</button>
    </div>
    <div class="d-flex justify-content-center mt-2">
        <div v-if="!hasFile" class="input-import" @click="addImg">
            <div>
                <div class="d-flex justify-content-center mb-3">
                    <i class="fas fa-cloud-download-alt" style="font-size: 80px"></i>
                </div>
                <p id="font-pdf">Baixe o PDF acima,adicione a assinatura e insira aqui o documento assinado!</p>
            </div>
        </div>
        <div v-else class="input-with-file">
            <div @click="removeFile" id="remove-file">X</div>
            <i class="fas fa-file-pdf" style="font-size: 80px;color: #028849"></i>
            <div id="footer-file">{{nameFile}}</div>
        </div>
    </div>
    <input type="file" @change="setValueInput" style="visibility:hidden" id="input-hidden" accept="application/pdf  ">
  </div>

</template>

<script>
import SingModal from './SingModal'
export default SingModal
</script>

<style scoped>
#font-pdf{
    font-size: 20px;
    text-align: center;
    font-weight: bold;
}
.btn-dowload{
    width: 40%;
    height: 45px;
    border: none;
    background: #025e33;
    border-radius: 10px;
    color: white;
    font-size: 16px;
}
.btn-dowload:hover{
    background: #028849;

}
.input-with-file{
    width: 40%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    height: 350px;
    position: relative;
    border-radius: 10px;
    border: 1px solid #028849;
}
#remove-file{
    height: 65px;
    width: 65px;
    border-radius: 0 10px 0 50%;
    top: 0;
    right: 0;
    position: absolute;
    color: white;
    font-size: 24px;
    font-weight: bold;
    background: red;
    display: flex;
    justify-content: center;
    align-items: center;
}
#footer-file{
    position: absolute;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    color: white;
    background: #028849;
    border-radius: 0 0 10px 10px;
    font-size: 24px;
    width: 100%;
}
#remove-file:hover{
    background: rgb(182, 1, 1);
}
.input-import{
    width: 40%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    height: 350px;
    border-radius: 10px;
    border: 1px dashed black;
}
</style>



// WEBPACK FOOTER //
// src/views/private/travelreimbursement/components/SingModal/SingModal.vue